import { render } from "./2_Plattenart.vue?vue&type=template&id=5f186c80"
import script from "./2_Plattenart.vue?vue&type=script&lang=js"
export * from "./2_Plattenart.vue?vue&type=script&lang=js"

import exportComponent from "/home/tristobombo/PHPStormProjects/ITW-webapp-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__